(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfect-match-guided-consultation"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-perfect-match]').forEach(function(root){
      var form=root.querySelector('[data-quiz]'),steps=Array.prototype.slice.call(root.querySelectorAll('[data-step]')),current=0;
      var back=root.querySelector('[data-back]'),next=root.querySelector('[data-next]'),reveal=root.querySelector('[data-reveal]');
      var progress=root.querySelector('[data-progress]'),number=root.querySelector('[data-step-number]'),resultPanel=root.querySelector('[data-result-panel]');
      root.querySelector('[data-step-total]').textContent=steps.length;
      function render(){steps.forEach(function(step,index){step.hidden=index!==current});back.hidden=current===0;next.hidden=current===steps.length-1;reveal.hidden=current!==steps.length-1;number.textContent=current+1;progress.style.width=((current+1)/steps.length*100)+'%'}
      function valid(){var selected=steps[current].querySelector('input:checked');if(!selected){steps[current].querySelector('input').focus();return false}return true}
      function answers(){var data={};new FormData(form).forEach(function(value,key){data[key]=value});return data}
      function add(scores,keys,amount){keys.forEach(function(key){scores[key]+=amount})}
      function recommendation(a){
        var s={genius:0,flat_weft:0,butterfly:0,machine:0,invisi_tape:0,classic_tape:0,nano:0,u_tip:0,flat_tip:0};
        if(a.goal==='volume')add(s,['genius','flat_weft','invisi_tape'],3);
        if(a.goal==='length')add(s,['genius','nano','u_tip','flat_tip'],3);
        if(a.goal==='both')add(s,['genius','flat_weft','butterfly','invisi_tape'],3);
        if(a.goal==='maximum')add(s,['machine','butterfly','flat_weft'],5);
        if(a.strand==='fine'){add(s,['genius','invisi_tape'],5);add(s,['nano','u_tip','flat_tip'],3);add(s,['machine'],-5);add(s,['butterfly'],-3)}
        if(a.strand==='medium')add(s,['flat_weft','butterfly','classic_tape','nano','u_tip','flat_tip'],2);
        if(a.strand==='coarse')add(s,['machine','butterfly','flat_weft','classic_tape'],4);
        if(a.density==='low'){add(s,['genius','invisi_tape'],5);add(s,['nano','u_tip','flat_tip'],2);add(s,['machine'],-8);add(s,['butterfly'],-6);add(s,['classic_tape'],-3)}
        if(a.density==='medium')add(s,['genius','flat_weft','invisi_tape','nano','u_tip','flat_tip'],2);
        if(a.density==='high'){add(s,['machine','butterfly'],6);add(s,['flat_weft','classic_tape'],4)}
        if(a.condition==='fragile'||a.condition==='thinning'){add(s,['genius','invisi_tape'],3);add(s,['machine','butterfly'],-7);add(s,['nano','u_tip','flat_tip'],-2)}
        if(a.coverage==='sides')add(s,['nano','u_tip','flat_tip'],7);
        if(a.coverage==='lower')add(s,['genius','flat_weft','butterfly','machine'],3);
        if(a.coverage==='ends')add(s,['invisi_tape','classic_tape','genius'],2);
        if(a.upstyles==='often')add(s,['nano','u_tip','flat_tip'],5);
        if(a.upstyles==='sometimes')add(s,['nano','u_tip','flat_tip'],2);
        if(a.priority==='discreet')add(s,['genius','invisi_tape','nano','flat_tip'],5);
        if(a.priority==='speed')add(s,['butterfly','classic_tape','invisi_tape'],6);
        if(a.priority==='movement')add(s,['nano','u_tip','flat_tip'],6);
        if(a.priority==='volume')add(s,['machine','butterfly','flat_weft'],5);
        if(a.attachment==='no_adhesive'){add(s,['invisi_tape','classic_tape'],-12);add(s,['genius','flat_weft','butterfly','machine','nano'],3)}
        if(a.attachment==='no_heat'){add(s,['u_tip','flat_tip'],-12);add(s,['genius','flat_weft','butterfly','machine','nano','invisi_tape','classic_tape'],2)}
        if(a.attachment==='no_beads'){add(s,['nano','butterfly'],-12);add(s,['invisi_tape','classic_tape','u_tip','flat_tip'],3)}
        return Object.keys(s).sort(function(x,y){return s[y]-s[x]})[0];
      }
      function grams(a){
        var result='150 g · Signature Volume';
        if(a.fullness==='natural')result='100 g · Natural Enhancement';
        if(a.fullness==='very')result=a.density==='low'?'150 g · Signature Volume':'200–250 g · Luxe Fullness';
        if(a.fullness==='maximum')result=a.density==='high'?'300 g · Maximum Volume':(a.density==='low'?'150 g · Signature Volume':'250 g · Glamour Volume');
        if(a.condition==='fragile'||a.condition==='thinning')result='100–150 g · Lightweight fullness';
        return result;
      }
      function showResult(){
        var a=answers(),primary=recommendation(a),method=root.querySelector('[data-method="'+primary+'"]');
        root.querySelector('[data-result-title]').textContent=method.dataset.name;
        root.querySelector('[data-result-summary]').textContent=method.dataset.summary;
        root.querySelector('[data-result-length]').textContent=a.length+' inches';
        root.querySelector('[data-result-grams]').textContent=grams(a);
        root.querySelector('[data-result-quality]').textContent=(a.quality==='super'||a.fullness==='maximum')?'Super Double Drawn A+++':'Double Drawn A++';
        root.querySelector('[data-product-link]').href=method.dataset.url;
        var reasons=[];
        if(a.priority==='discreet')reasons.push('you prioritised a discreet, low-profile finish');
        if(a.priority==='speed')reasons.push('you value an efficient installation');
        if(a.priority==='movement')reasons.push('you want flexible placement and natural movement');
        if(a.priority==='volume')reasons.push('you want substantial, durable volume');
        if(a.density==='low')reasons.push('your overall density calls for a lighter, more considered approach');
        if(a.density==='high')reasons.push('your natural density can conceal a more substantial installation');
        root.querySelector('[data-result-why]').textContent='This recommendation reflects that '+reasons.join(' and ')+'.';
        var hybrid=root.querySelector('[data-hybrid]'),foundation=['genius','flat_weft','butterfly','machine','invisi_tape','classic_tape'].indexOf(primary)>-1;
        if(foundation&&(a.coverage==='sides'||a.upstyles==='often')){
          var supplement=a.attachment==='no_heat'?'nano':(a.attachment==='no_beads'?'flat_tip':'nano');
          root.querySelector('[data-hybrid-title]').textContent=method.dataset.name+' + '+root.querySelector('[data-method="'+supplement+'"]').dataset.name;
          hybrid.hidden=false;
        }else hybrid.hidden=true;
        form.hidden=true;root.querySelector('.tmhc-consult__progress').hidden=true;root.querySelector('.tmhc-consult__counter').hidden=true;resultPanel.hidden=false;resultPanel.focus();root.scrollIntoView({behavior:'smooth',block:'start'});
      }
      next.addEventListener('click',function(){if(valid()&&current<steps.length-1){current++;render();root.scrollIntoView({behavior:'smooth',block:'start'})}});
      back.addEventListener('click',function(){if(current>0){current--;render();root.scrollIntoView({behavior:'smooth',block:'start'})}});
      form.addEventListener('submit',function(event){event.preventDefault();if(valid())showResult()});
      root.querySelector('[data-restart]').addEventListener('click',function(){form.reset();current=0;resultPanel.hidden=true;form.hidden=false;root.querySelector('.tmhc-consult__progress').hidden=false;root.querySelector('.tmhc-consult__counter').hidden=false;render();root.scrollIntoView({behavior:'smooth',block:'start'})});
      render();
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfect-match-shade-chart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-shade-button]');
    if (!button) return;
    var section = button.closest('.tmhc-shades');
    section.querySelectorAll('[data-shade-button]').forEach(function (item) { item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
    var selection = section.querySelector('[data-shade-selection]');
    if (selection) selection.textContent = 'Selected shade: ' + button.dataset.shadeName;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
